import { FormInstance } from "antd/es/form";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHedefTanim_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHedefTanim_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoalsSave: number;
  GoalsSave_dummy: number;
  GoalDealerSave: number;
  GoalDealerSave_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  CheckQ1Id: any[];
  CheckQ1Id_dummy: any[];
  GoalsQDetailSave: number;
  GoalsQDetailSave_dummy: number;
  CheckQ2Id: any[];
  CheckQ2Id_dummy: any[];
  CheckQ3Id: any[];
  CheckQ3Id_dummy: any[];
  CheckQ4Id: any[];
  CheckQ4Id_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  SelectDealerGoalsByGoalId: any[];
  SelectDealerGoalsByGoalId_dummy: any[];
  sbDealer: any[];
  sbDealer_dummy: any[];
  GoalsById: any[];
  GoalsById_dummy: any[];
  sbGoalTypesAll: any[];
  sbGoalTypesAll_dummy: any[];
  SelectGoalsQDetailByGoaldQ1: any[];
  SelectGoalsQDetailByGoaldQ1_dummy: any[];
  SelectGoalsQDetailByGoaldQ2: any[];
  SelectGoalsQDetailByGoaldQ2_dummy: any[];
  SelectGoalsQDetailByGoaldQ3: any[];
  SelectGoalsQDetailByGoaldQ3_dummy: any[];
  SelectGoalsQDetailByGoaldQ4: any[];
  SelectGoalsQDetailByGoaldQ4_dummy: any[];
  GoalCheckWithDelaerIdAndValidYear: any[];
  GoalCheckWithDelaerIdAndValidYear_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  isComp130675Visible: "visible" | "hidden";
  isComp46695Visible: "visible" | "hidden";
  isComp391875Visible: "visible" | "hidden";
  isComp767868Visible: "visible" | "hidden";
  isComp509700Visible: "visible" | "hidden";
  isComp154172Visible: "visible" | "hidden";
  isComp945657Visible: "visible" | "hidden";
  isComp491622Visible: "visible" | "hidden";
  isComp358684Visible: "visible" | "hidden";
  isComp402170Visible: "visible" | "hidden";
  isComp580995Visible: "visible" | "hidden";
  isComp909091Visible: "visible" | "hidden";
  isComp179257Visible: "visible" | "hidden";
  isComp637117Visible: "visible" | "hidden";
  isComp247824Visible: "visible" | "hidden";
  isComp208794Visible: "visible" | "hidden";
  isComp907429Visible: "visible" | "hidden";
  isComp190246Visible: "visible" | "hidden";
  isComp625815Visible: "visible" | "hidden";
  isComp981409Visible: "visible" | "hidden";
  isComp750471Visible: "visible" | "hidden";
  isComp238038Visible: "visible" | "hidden";
  isComp93394Visible: "visible" | "hidden";
  isComp480196Visible: "visible" | "hidden";
  isComp573643Visible: "visible" | "hidden";
  isComp344190Visible: "visible" | "hidden";
  isComp451899Visible: "visible" | "hidden";
  isComp760393Visible: "visible" | "hidden";
  isComp395207Visible: "visible" | "hidden";
  isComp852872Visible: "visible" | "hidden";
  isComp692143Visible: "visible" | "hidden";
  isComp188875Visible: "visible" | "hidden";
}

export class HedefTanim_ScreenBase extends React.PureComponent<
  IHedefTanim_ScreenProps,
  any
> {
  hedeftanim_242316_value_kuikaSelectBoxRef: React.RefObject<any>;
  hedeftanim_572273_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "69a045b2-451e-402f-9a99-eec0d2f9a0c1",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 657512, PropertyName: "label", Value: "Kaydet" },
        { Id: 150725, PropertyName: "value", Value: "Hedef Tanımlama" },
        { Id: 718826, PropertyName: "value", Value: "Hedef Adı" },
        {
          Id: 140549,
          PropertyName: "placeholder",
          Value: "Hedef adı girin...",
        },
        { Id: 334559, PropertyName: "value", Value: "Hedef Tanımı" },
        {
          Id: 297157,
          PropertyName: "placeholder",
          Value: "Hedef tanımını yazın...",
        },
        { Id: 558460, PropertyName: "value", Value: "Hedef Tipi" },
        {
          Id: 242316,
          PropertyName: "placeholder",
          Value: "Hedef tipi seçin...",
        },
        { Id: 921461, PropertyName: "value", Value: "Bayi Seçimi" },
        { Id: 572273, PropertyName: "placeholder", Value: "Bayi seçin..." },
        { Id: 929582, PropertyName: "value", Value: "Yıl" },
        { Id: 154860, PropertyName: "placeholder", Value: "Yıl seçin..." },
        { Id: 957751, PropertyName: "value", Value: "1. Çeyrek" },
        { Id: 774094, PropertyName: "value", Value: "PowerBox Adet" },
        {
          Id: 166852,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 220088, PropertyName: "value", Value: "Dizel Adet 2" },
        {
          Id: 7219,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 520949, PropertyName: "value", Value: "Jenerator Satış Ciro" },
        {
          Id: 291437,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 901099, PropertyName: "value", Value: "Dizel Ciro 2" },
        {
          Id: 548666,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 803503, PropertyName: "value", Value: "Portatif Adet" },
        {
          Id: 327250,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 586409, PropertyName: "value", Value: "Portatif Ciro" },
        {
          Id: 611988,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 880321, PropertyName: "value", Value: "Periyodik Satış Adet" },
        {
          Id: 87319,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 154153, PropertyName: "value", Value: "Vade Ödeme" },
        {
          Id: 568205,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 187806, PropertyName: "value", Value: "Stok" },
        {
          Id: 959035,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 336005, PropertyName: "value", Value: "Yedek Parça Ciro" },
        {
          Id: 216291,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
        { Id: 650837, PropertyName: "value", Value: "Yedek Parça Cirosu 2" },
        {
          Id: 737193,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
        { Id: 654088, PropertyName: "value", Value: "2. Çeyrek" },
        { Id: 571244, PropertyName: "value", Value: "PowerBox Adet" },
        {
          Id: 997753,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 872600, PropertyName: "value", Value: "Dizel Adet 2" },
        {
          Id: 844129,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 311840, PropertyName: "value", Value: "Jenerator Satış Ciro" },
        {
          Id: 131532,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 789020, PropertyName: "value", Value: "Dizel Ciro 2" },
        {
          Id: 342814,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 344860, PropertyName: "value", Value: "Portatif Adet" },
        {
          Id: 883045,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 742741, PropertyName: "value", Value: "Portatif Ciro" },
        {
          Id: 550030,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 426908, PropertyName: "value", Value: "Periyodik Satış Adet" },
        {
          Id: 815437,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 102677, PropertyName: "value", Value: "Vade Ödeme" },
        {
          Id: 508471,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 574555, PropertyName: "value", Value: "Stok" },
        {
          Id: 55554,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 933044, PropertyName: "value", Value: "Yedek Parça Ciro" },
        {
          Id: 890962,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
        { Id: 979295, PropertyName: "value", Value: "Yedek Parça Cirosu 2" },
        {
          Id: 840360,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
        { Id: 339886, PropertyName: "value", Value: "3. Çeyrek" },
        { Id: 974073, PropertyName: "value", Value: "PowerBox Adet" },
        {
          Id: 684432,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 470617, PropertyName: "value", Value: "Dizel Adet 2" },
        {
          Id: 5555,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 193882, PropertyName: "value", Value: "Jenerator Satış Ciro" },
        {
          Id: 529467,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 93103, PropertyName: "value", Value: "Dizel Ciro 2" },
        {
          Id: 192917,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 243429, PropertyName: "value", Value: "Portatif Adet" },
        {
          Id: 305758,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 790639, PropertyName: "value", Value: "Portatif Ciro" },
        {
          Id: 816593,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 601569, PropertyName: "value", Value: "Periyodik Satış Adet" },
        {
          Id: 377308,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 979770, PropertyName: "value", Value: "Vade Ödeme" },
        {
          Id: 222794,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 161549, PropertyName: "value", Value: "Stok" },
        {
          Id: 636605,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 194018, PropertyName: "value", Value: "Yedek Parça Ciro" },
        {
          Id: 883489,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
        { Id: 624550, PropertyName: "value", Value: "Yedek Parça Cirosu 2" },
        {
          Id: 235290,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
        { Id: 241490, PropertyName: "value", Value: "4. Çeyrek" },
        { Id: 386869, PropertyName: "value", Value: "PowerBox Adet" },
        {
          Id: 508737,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 971088, PropertyName: "value", Value: "Dizel Adet 2" },
        {
          Id: 520922,
          PropertyName: "placeholder",
          Value: "Dizel adet belirtin...",
        },
        { Id: 746923, PropertyName: "value", Value: "Jenerator Satış Ciro" },
        {
          Id: 808841,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 299241, PropertyName: "value", Value: "Dizel Ciro 2" },
        {
          Id: 537073,
          PropertyName: "placeholder",
          Value: "Dizel cirosunu belirtin...",
        },
        { Id: 760365, PropertyName: "value", Value: "Portatif Adet" },
        {
          Id: 657382,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 910854, PropertyName: "value", Value: "Portatif Ciro" },
        {
          Id: 85811,
          PropertyName: "placeholder",
          Value: "Portatif adeti belirtin...",
        },
        { Id: 525894, PropertyName: "value", Value: "Periyodik Satış Adet" },
        {
          Id: 409786,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 278280, PropertyName: "value", Value: "Vade Ödeme" },
        {
          Id: 366218,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 987053, PropertyName: "value", Value: "Stok" },
        {
          Id: 144657,
          PropertyName: "placeholder",
          Value: "Portatif cirosunu belirtin...",
        },
        { Id: 564584, PropertyName: "value", Value: "Yedek Parça Ciro" },
        {
          Id: 49893,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
        { Id: 891557, PropertyName: "value", Value: "Yedek Parça Cirosu 2" },
        {
          Id: 421946,
          PropertyName: "placeholder",
          Value: "Yedek parça cirosunu belirtin...",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.hedeftanim_140549_value_kuikaTextInputRef = React.createRef();
    this.hedeftanim_242316_value_kuikaSelectBoxRef = React.createRef();
    this.hedeftanim_572273_value_kuikaAutoCompleteRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoalsSave: 0,
      IfThenElse: false,
      CheckQ1Id: [],
      GoalsQDetailSave: 0,
      CheckQ2Id: [],
      CheckQ3Id: [],
      CheckQ4Id: [],
      GoBack: "",
      SelectDealerGoalsByGoalId: [],
      sbDealer: [],
      GoalsById: [],
      sbGoalTypesAll: [],
      SelectGoalsQDetailByGoaldQ1: [],
      SelectGoalsQDetailByGoaldQ2: [],
      SelectGoalsQDetailByGoaldQ3: [],
      SelectGoalsQDetailByGoaldQ4: [],
      GoalCheckWithDelaerIdAndValidYear: [],
      isComp130675Visible: "hidden",
      isComp46695Visible: "hidden",
      isComp391875Visible: "hidden",
      isComp767868Visible: "hidden",
      isComp509700Visible: "hidden",
      isComp154172Visible: "hidden",
      isComp945657Visible: "hidden",
      isComp491622Visible: "hidden",
      isComp358684Visible: "hidden",
      isComp402170Visible: "hidden",
      isComp580995Visible: "hidden",
      isComp909091Visible: "hidden",
      isComp179257Visible: "hidden",
      isComp637117Visible: "hidden",
      isComp247824Visible: "hidden",
      isComp208794Visible: "hidden",
      isComp907429Visible: "hidden",
      isComp190246Visible: "hidden",
      isComp625815Visible: "hidden",
      isComp981409Visible: "hidden",
      isComp750471Visible: "hidden",
      isComp238038Visible: "hidden",
      isComp93394Visible: "hidden",
      isComp480196Visible: "hidden",
      isComp573643Visible: "hidden",
      isComp344190Visible: "hidden",
      isComp451899Visible: "hidden",
      isComp760393Visible: "hidden",
      isComp395207Visible: "hidden",
      isComp852872Visible: "hidden",
      isComp692143Visible: "hidden",
      isComp188875Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("hedeftanim", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HedefTanimPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("hedeftanim", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Admin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("hedeftanim", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HedefTanimPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      hedeftanim_140549_value: this.state.GoalsById?.at?.(0)?.name ?? undefined,
      hedeftanim_297157_value:
        this.state.GoalsById?.at?.(0)?.description ?? undefined,
      hedeftanim_242316_value:
        this.state.GoalsById?.at?.(0)?.goalType ?? undefined,
      hedeftanim_572273_value:
        this.state.SelectDealerGoalsByGoalId?.at?.(0)?.dealerID ?? undefined,
      hedeftanim_154860_value:
        this.state.GoalsById?.at?.(0)?.validYear ?? undefined,
      hedeftanim_166852_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.dieselQuantity ??
        undefined,
      hedeftanim_7219_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.dieselQuantity2 ??
        undefined,
      hedeftanim_291437_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.dieselTurnover ??
        undefined,
      hedeftanim_548666_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.dieselTurnover2 ??
        undefined,
      hedeftanim_327250_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.portableQuantity ??
        undefined,
      hedeftanim_611988_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.portableTurnover ??
        undefined,
      hedeftanim_87319_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)
          ?.periodicSalesQuantity ?? undefined,
      hedeftanim_568205_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.maturityPayment ??
        undefined,
      hedeftanim_959035_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.stock ?? undefined,
      hedeftanim_216291_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.sparePartTurnover ??
        undefined,
      hedeftanim_737193_value:
        this.state.SelectGoalsQDetailByGoaldQ1?.at?.(0)?.sparePartTurnover2 ??
        undefined,
      hedeftanim_997753_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.dieselQuantity ??
        undefined,
      hedeftanim_844129_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.dieselQuantity2 ??
        undefined,
      hedeftanim_131532_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.dieselTurnover ??
        undefined,
      hedeftanim_342814_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.dieselTurnover2 ??
        undefined,
      hedeftanim_883045_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.portableQuantity ??
        undefined,
      hedeftanim_550030_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.portableTurnover ??
        undefined,
      hedeftanim_815437_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)
          ?.periodicSalesQuantity ?? undefined,
      hedeftanim_508471_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.maturityPayment ??
        undefined,
      hedeftanim_55554_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.stock ?? undefined,
      hedeftanim_890962_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.sparePartTurnover ??
        undefined,
      hedeftanim_840360_value:
        this.state.SelectGoalsQDetailByGoaldQ2?.at?.(0)?.sparePartTurnover2 ??
        undefined,
      hedeftanim_684432_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.dieselQuantity ??
        undefined,
      hedeftanim_5555_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.dieselQuantity2 ??
        undefined,
      hedeftanim_529467_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.dieselTurnover ??
        undefined,
      hedeftanim_192917_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.dieselTurnover2 ??
        undefined,
      hedeftanim_305758_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.portableQuantity ??
        undefined,
      hedeftanim_816593_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.portableTurnover ??
        undefined,
      hedeftanim_377308_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)
          ?.periodicSalesQuantity ?? undefined,
      hedeftanim_222794_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.maturityPayment ??
        undefined,
      hedeftanim_636605_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.stock ?? undefined,
      hedeftanim_883489_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.sparePartTurnover ??
        undefined,
      hedeftanim_235290_value:
        this.state.SelectGoalsQDetailByGoaldQ3?.at?.(0)?.sparePartTurnover2 ??
        undefined,
      hedeftanim_508737_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.dieselQuantity ??
        undefined,
      hedeftanim_520922_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.dieselQuantity2 ??
        undefined,
      hedeftanim_808841_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.dieselTurnover ??
        undefined,
      hedeftanim_537073_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.dieselTurnover2 ??
        undefined,
      hedeftanim_657382_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.portableQuantity ??
        undefined,
      hedeftanim_85811_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.portableTurnover ??
        undefined,
      hedeftanim_409786_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)
          ?.periodicSalesQuantity ?? undefined,
      hedeftanim_366218_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.maturityPayment ??
        undefined,
      hedeftanim_144657_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.stock ?? undefined,
      hedeftanim_49893_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.sparePartTurnover ??
        undefined,
      hedeftanim_421946_value:
        this.state.SelectGoalsQDetailByGoaldQ4?.at?.(0)?.sparePartTurnover2 ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HedefTanimPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      GoalId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      GoalId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      GoalId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      GoalId_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      GoalId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      GoalId_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTanim/HedefTanimPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectDealerGoalsByGoalId =
      result?.data.selectDealerGoalsByGoalId;
    formVars.hedeftanim_572273_value =
      stateVars.SelectDealerGoalsByGoalId !== undefined
        ? stateVars.SelectDealerGoalsByGoalId?.length > 0
          ? stateVars.SelectDealerGoalsByGoalId[0].dealerID
          : null
        : this.state.SelectDealerGoalsByGoalId?.length > 0
        ? this.state.SelectDealerGoalsByGoalId[0].dealerID
        : null;
    formVars.hedeftanim_572273_options = stateVars.sbDealer;
    stateVars.sbDealer = result?.data.sbDealer;

    formVars.hedeftanim_572273_value =
      stateVars.SelectDealerGoalsByGoalId !== undefined
        ? stateVars.SelectDealerGoalsByGoalId?.length > 0
          ? stateVars.SelectDealerGoalsByGoalId[0].dealerID
          : null
        : this.state.SelectDealerGoalsByGoalId?.length > 0
        ? this.state.SelectDealerGoalsByGoalId[0].dealerID
        : null;
    formVars.hedeftanim_572273_options = stateVars.sbDealer;
    stateVars.GoalsById = result?.data.goalsById;
    formVars.hedeftanim_140549_value = ReactSystemFunctions.toString(
      this,
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].name
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].name
        : null
    );
    formVars.hedeftanim_297157_value = ReactSystemFunctions.toString(
      this,
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].description
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].description
        : null
    );
    formVars.hedeftanim_242316_value =
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].goalType
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].goalType
        : null;
    formVars.hedeftanim_242316_options = stateVars.sbGoalTypesAll;
    formVars.hedeftanim_154860_value = ReactSystemFunctions.value(
      this,
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].validYear
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].validYear
        : null
    );
    stateVars.sbGoalTypesAll = result?.data.sbGoalTypesAll;

    formVars.hedeftanim_242316_value =
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].goalType
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].goalType
        : null;
    formVars.hedeftanim_242316_options = stateVars.sbGoalTypesAll;
    stateVars.SelectGoalsQDetailByGoaldQ1 =
      result?.data.selectGoalsQDetailByGoaldQ1;
    formVars.hedeftanim_166852_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity
        : null
    );
    formVars.hedeftanim_7219_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity2
        : null
    );
    formVars.hedeftanim_291437_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover
        : null
    );
    formVars.hedeftanim_548666_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover2
        : null
    );
    formVars.hedeftanim_327250_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].portableQuantity
        : null
    );
    formVars.hedeftanim_611988_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].portableTurnover
        : null
    );
    formVars.hedeftanim_87319_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].periodicSalesQuantity
        : null
    );
    formVars.hedeftanim_568205_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].maturityPayment
        : null
    );
    formVars.hedeftanim_959035_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].stock
        : null
    );
    formVars.hedeftanim_216291_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover
        : null
    );
    formVars.hedeftanim_737193_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover2
        : null
    );
    stateVars.SelectGoalsQDetailByGoaldQ2 =
      result?.data.selectGoalsQDetailByGoaldQ2;
    formVars.hedeftanim_997753_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity
        : null
    );
    formVars.hedeftanim_844129_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity2
        : null
    );
    formVars.hedeftanim_131532_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover
        : null
    );
    formVars.hedeftanim_342814_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover2
        : null
    );
    formVars.hedeftanim_883045_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].portableQuantity
        : null
    );
    formVars.hedeftanim_550030_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].portableTurnover
        : null
    );
    formVars.hedeftanim_815437_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].periodicSalesQuantity
        : null
    );
    formVars.hedeftanim_508471_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].maturityPayment
        : null
    );
    formVars.hedeftanim_55554_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].stock
        : null
    );
    formVars.hedeftanim_890962_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover
        : null
    );
    formVars.hedeftanim_840360_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover2
        : null
    );
    stateVars.SelectGoalsQDetailByGoaldQ3 =
      result?.data.selectGoalsQDetailByGoaldQ3;
    formVars.hedeftanim_684432_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity
        : null
    );
    formVars.hedeftanim_5555_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity2
        : null
    );
    formVars.hedeftanim_529467_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover
        : null
    );
    formVars.hedeftanim_192917_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover2
        : null
    );
    formVars.hedeftanim_305758_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].portableQuantity
        : null
    );
    formVars.hedeftanim_816593_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].portableTurnover
        : null
    );
    formVars.hedeftanim_377308_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].periodicSalesQuantity
        : null
    );
    formVars.hedeftanim_222794_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].maturityPayment
        : null
    );
    formVars.hedeftanim_636605_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].stock
        : null
    );
    formVars.hedeftanim_883489_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover
        : null
    );
    formVars.hedeftanim_235290_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover2
        : null
    );
    stateVars.SelectGoalsQDetailByGoaldQ4 =
      result?.data.selectGoalsQDetailByGoaldQ4;
    formVars.hedeftanim_508737_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity
        : null
    );
    formVars.hedeftanim_520922_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity2
        : null
    );
    formVars.hedeftanim_808841_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover
        : null
    );
    formVars.hedeftanim_537073_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover2
        : null
    );
    formVars.hedeftanim_657382_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].portableQuantity
        : null
    );
    formVars.hedeftanim_85811_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].portableTurnover
        : null
    );
    formVars.hedeftanim_409786_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].periodicSalesQuantity
        : null
    );
    formVars.hedeftanim_366218_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].maturityPayment
        : null
    );
    formVars.hedeftanim_144657_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].stock
        : null
    );
    formVars.hedeftanim_49893_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover
        : null
    );
    formVars.hedeftanim_421946_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover2
        : null
    );
    stateVars.SelectDealerGoalsByGoalId =
      result?.data.selectDealerGoalsByGoalId;
    formVars.hedeftanim_572273_value =
      stateVars.SelectDealerGoalsByGoalId !== undefined
        ? stateVars.SelectDealerGoalsByGoalId?.length > 0
          ? stateVars.SelectDealerGoalsByGoalId[0].dealerID
          : null
        : this.state.SelectDealerGoalsByGoalId?.length > 0
        ? this.state.SelectDealerGoalsByGoalId[0].dealerID
        : null;
    formVars.hedeftanim_572273_options = stateVars.sbDealer;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTanimPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefTanimPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.hedeftanim_140549_value = ReactSystemFunctions.toString(
      this,
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].name
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].name
        : null
    );

    formVars.hedeftanim_297157_value = ReactSystemFunctions.toString(
      this,
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].description
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].description
        : null
    );

    formVars.hedeftanim_242316_value = ReactSystemFunctions.toString(
      this,
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].goalType
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].goalType
        : null
    );

    stateVars.dataSource_242316 =
      stateVars.sbGoalTypesAll ?? this.state.sbGoalTypesAll;
    stateVars.dataSource_242316 =
      stateVars.sbGoalTypesAll ?? this.state.sbGoalTypesAll;
    formVars.hedeftanim_572273_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectDealerGoalsByGoalId !== undefined
        ? stateVars.SelectDealerGoalsByGoalId?.length > 0
          ? stateVars.SelectDealerGoalsByGoalId[0].dealerID
          : null
        : this.state.SelectDealerGoalsByGoalId?.length > 0
        ? this.state.SelectDealerGoalsByGoalId[0].dealerID
        : null
    );

    stateVars.dataSource_572273 = stateVars.sbDealer ?? this.state.sbDealer;
    stateVars.dataSource_572273 = stateVars.sbDealer ?? this.state.sbDealer;
    formVars.hedeftanim_154860_value = ReactSystemFunctions.value(
      this,
      stateVars.GoalsById !== undefined
        ? stateVars.GoalsById?.length > 0
          ? stateVars.GoalsById[0].validYear
          : null
        : this.state.GoalsById?.length > 0
        ? this.state.GoalsById[0].validYear
        : null
    );

    formVars.hedeftanim_166852_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity
        : null
    );

    formVars.hedeftanim_7219_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselQuantity2
        : null
    );

    formVars.hedeftanim_291437_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover
        : null
    );

    formVars.hedeftanim_548666_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].dieselTurnover2
        : null
    );

    formVars.hedeftanim_327250_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].portableQuantity
        : null
    );

    formVars.hedeftanim_611988_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].portableTurnover
        : null
    );

    formVars.hedeftanim_87319_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].periodicSalesQuantity
        : null
    );

    formVars.hedeftanim_568205_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].maturityPayment
        : null
    );

    formVars.hedeftanim_959035_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].stock
        : null
    );

    formVars.hedeftanim_216291_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover
        : null
    );

    formVars.hedeftanim_737193_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ1 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ1?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ1?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ1[0].sparePartTurnover2
        : null
    );

    formVars.hedeftanim_997753_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity
        : null
    );

    formVars.hedeftanim_844129_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselQuantity2
        : null
    );

    formVars.hedeftanim_131532_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover
        : null
    );

    formVars.hedeftanim_342814_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].dieselTurnover2
        : null
    );

    formVars.hedeftanim_883045_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].portableQuantity
        : null
    );

    formVars.hedeftanim_550030_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].portableTurnover
        : null
    );

    formVars.hedeftanim_815437_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].periodicSalesQuantity
        : null
    );

    formVars.hedeftanim_508471_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].maturityPayment
        : null
    );

    formVars.hedeftanim_55554_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].stock
        : null
    );

    formVars.hedeftanim_890962_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover
        : null
    );

    formVars.hedeftanim_840360_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ2 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ2?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ2?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ2[0].sparePartTurnover2
        : null
    );

    formVars.hedeftanim_684432_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity
        : null
    );

    formVars.hedeftanim_5555_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselQuantity2
        : null
    );

    formVars.hedeftanim_529467_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover
        : null
    );

    formVars.hedeftanim_192917_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].dieselTurnover2
        : null
    );

    formVars.hedeftanim_305758_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].portableQuantity
        : null
    );

    formVars.hedeftanim_816593_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].portableTurnover
        : null
    );

    formVars.hedeftanim_377308_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].periodicSalesQuantity
        : null
    );

    formVars.hedeftanim_222794_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].maturityPayment
        : null
    );

    formVars.hedeftanim_636605_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].stock
        : null
    );

    formVars.hedeftanim_883489_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover
        : null
    );

    formVars.hedeftanim_235290_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ3 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ3?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ3?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ3[0].sparePartTurnover2
        : null
    );

    formVars.hedeftanim_508737_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity
        : null
    );

    formVars.hedeftanim_520922_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselQuantity2
        : null
    );

    formVars.hedeftanim_808841_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover
        : null
    );

    formVars.hedeftanim_537073_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].dieselTurnover2
        : null
    );

    formVars.hedeftanim_657382_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].portableQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].portableQuantity
        : null
    );

    formVars.hedeftanim_85811_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].portableTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].portableTurnover
        : null
    );

    formVars.hedeftanim_409786_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].periodicSalesQuantity
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].periodicSalesQuantity
        : null
    );

    formVars.hedeftanim_366218_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].maturityPayment
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].maturityPayment
        : null
    );

    formVars.hedeftanim_144657_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].stock
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].stock
        : null
    );

    formVars.hedeftanim_49893_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover
        : null
    );

    formVars.hedeftanim_421946_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectGoalsQDetailByGoaldQ4 !== undefined
        ? stateVars.SelectGoalsQDetailByGoaldQ4?.length > 0
          ? stateVars.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover2
          : null
        : this.state.SelectGoalsQDetailByGoaldQ4?.length > 0
        ? this.state.SelectGoalsQDetailByGoaldQ4[0].sparePartTurnover2
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HedefTanimComponent_657512_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "hedeftanim_140549_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "hedeftanim_140549_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "hedeftanim_154860_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "*",
      formName: "hedeftanim_154860_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_297157_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      GoalType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_242316_value",
            "value",
            "sbGoalTypesAll",
            "id",
            ""
          )
        ),
        "Guid"
      ),
      IsActive_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_140549_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ValidYear_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_154860_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedBy_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTanim/HedefTanimComponent_657512_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalsSave = result?.data.goalsSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTanimComponent_657512_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefTanimComponent_657512_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "hedeftanim_572273_value",
          "value",
          "sbDealer",
          "id",
          ""
        ),
        null
      ),
      message: "*",
      formName: "hedeftanim_572273_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      GoalId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      DealerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_572273_value",
            "value",
            "sbDealer",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      IsEdit_0: ReactSystemFunctions.convertToTypeByName(false, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTanim/HedefTanimComponent_657512_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalDealerSave = result?.data.goalDealerSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  HedefTanimComponent_657512_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "hedeftanim_572273_value",
          "value",
          "sbDealer",
          "id",
          ""
        ),
        null
      ),
      message: "*",
      formName: "hedeftanim_572273_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      GoalId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      DealerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_572273_value",
            "value",
            "sbDealer",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      IsEdit_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTanim/HedefTanimComponent_657512_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalDealerSave = result?.data.goalDealerSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  HedefTanimComponent_657512_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GoalsById !== undefined
            ? stateVars.GoalsById?.length > 0
              ? stateVars.GoalsById[0].id
              : null
            : this.state.GoalsById?.length > 0
            ? this.state.GoalsById[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      isErrorOccurred = await this.HedefTanimComponent_657512_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.HedefTanimComponent_657512_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTanimComponent_657512_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HedefTanimComponent_657512_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      GoalId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      DieselQuantity_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_166852_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselQuantity2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_7219_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_291437_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_548666_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      MaturityPayment_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_568205_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PeriodicSalesQuantity_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_87319_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableQuantity_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_327250_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableTurnover_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_611988_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      SparePartTurnover_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_216291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SparePartTurnover2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_737193_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Stock_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_959035_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckQ1Id !== undefined
            ? stateVars.CheckQ1Id?.length > 0
              ? stateVars.CheckQ1Id[0].q1ID
              : null
            : this.state.CheckQ1Id?.length > 0
            ? this.state.CheckQ1Id[0].q1ID
            : null
        ),
        "Guid"
      ),
      GoalId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      DieselQuantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_997753_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselQuantity2_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_844129_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_131532_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover2_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_342814_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      MaturityPayment_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_508471_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PeriodicSalesQuantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_815437_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableQuantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_883045_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableTurnover_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_550030_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_3: ReactSystemFunctions.convertToTypeByName(2, "number"),
      SparePartTurnover_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_890962_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SparePartTurnover2_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_840360_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Stock_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_55554_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckQ2Id !== undefined
            ? stateVars.CheckQ2Id?.length > 0
              ? stateVars.CheckQ2Id[0].q1ID
              : null
            : this.state.CheckQ2Id?.length > 0
            ? this.state.CheckQ2Id[0].q1ID
            : null
        ),
        "Guid"
      ),
      GoalId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      DieselQuantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_684432_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselQuantity2_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_5555_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_529467_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover2_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_192917_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      MaturityPayment_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_222794_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PeriodicSalesQuantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_377308_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableQuantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_305758_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableTurnover_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_816593_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_5: ReactSystemFunctions.convertToTypeByName(3, "number"),
      SparePartTurnover_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_883489_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SparePartTurnover2_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_235290_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Stock_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_636605_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckQ3Id !== undefined
            ? stateVars.CheckQ3Id?.length > 0
              ? stateVars.CheckQ3Id[0].q1ID
              : null
            : this.state.CheckQ3Id?.length > 0
            ? this.state.CheckQ3Id[0].q1ID
            : null
        ),
        "Guid"
      ),
      GoalId_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      DieselQuantity_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_508737_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselQuantity2_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_520922_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_808841_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      DieselTurnover2_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_537073_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GoalId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ID ?? this.props.screenInputs.id,
        "Guid"
      ),
      MaturityPayment_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_366218_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PeriodicSalesQuantity_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_409786_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableQuantity_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_657382_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PortableTurnover_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_85811_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Quarter_7: ReactSystemFunctions.convertToTypeByName(4, "number"),
      SparePartTurnover_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_49893_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SparePartTurnover2_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_421946_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Stock_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_144657_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.CheckQ4Id !== undefined
            ? stateVars.CheckQ4Id?.length > 0
              ? stateVars.CheckQ4Id[0].q1ID
              : null
            : this.state.CheckQ4Id?.length > 0
            ? this.state.CheckQ4Id[0].q1ID
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTanim/HedefTanimComponent_657512_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CheckQ1Id = result?.data.checkQ1Id;
    stateVars.GoalsQDetailSave = result?.data.goalsQDetailSave;
    stateVars.CheckQ2Id = result?.data.checkQ2Id;
    stateVars.GoalsQDetailSave = result?.data.goalsQDetailSave;
    stateVars.CheckQ3Id = result?.data.checkQ3Id;
    stateVars.GoalsQDetailSave = result?.data.goalsQDetailSave;
    stateVars.CheckQ4Id = result?.data.checkQ4Id;
    stateVars.GoalsQDetailSave = result?.data.goalsQDetailSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTanimComponent_657512_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefTanimComponent_657512_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HedefTanimComponent_555343_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HedefTanimComponent_572273_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DealerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_572273_value",
            "value",
            "sbDealer",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_154860_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTanim/HedefTanimComponent_572273_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalCheckWithDelaerIdAndValidYear =
      result?.data.goalCheckWithDelaerIdAndValidYear;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTanimComponent_572273_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  HedefTanimComponent_572273_onChange_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hedeftanim_154860_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hedeftanim_572273_value",
        "string"
      ),
      null,
      null,
      "Id"
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "407ecbfe_af0f_952a_d1a4_b4c24fe577c7_notify",
        this.defaultML,
        "Seçilen bayi ve yıl için bir hedef bulunmakta."
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  HedefTanimComponent_572273_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GoalCheckWithDelaerIdAndValidYear !== undefined
            ? stateVars.GoalCheckWithDelaerIdAndValidYear?.length > 0
              ? stateVars.GoalCheckWithDelaerIdAndValidYear[0].isOk
              : null
            : this.state.GoalCheckWithDelaerIdAndValidYear?.length > 0
            ? this.state.GoalCheckWithDelaerIdAndValidYear[0].isOk
            : null
        ),
        "1"
      )
    ) {
    } else {
      isErrorOccurred = await this.HedefTanimComponent_572273_onChange_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HedefTanimComponent_154860_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DealerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_572273_value",
            "value",
            "sbDealer",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      ValidYear_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftanim_154860_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTanim/HedefTanimComponent_154860_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalCheckWithDelaerIdAndValidYear =
      result?.data.goalCheckWithDelaerIdAndValidYear;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTanimComponent_154860_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  HedefTanimComponent_154860_onChange_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hedeftanim_154860_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "hedeftanim_572273_value",
        "string"
      ),
      null,
      null,
      "Id"
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "3558bc25_d1aa_b85e_4726_3bcdb819922d_notify",
        this.defaultML,
        "Seçilen bayi ve yıl için bir hedef bulunmakta."
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  HedefTanimComponent_154860_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GoalCheckWithDelaerIdAndValidYear !== undefined
            ? stateVars.GoalCheckWithDelaerIdAndValidYear?.length > 0
              ? stateVars.GoalCheckWithDelaerIdAndValidYear[0].isOk
              : null
            : this.state.GoalCheckWithDelaerIdAndValidYear?.length > 0
            ? this.state.GoalCheckWithDelaerIdAndValidYear[0].isOk
            : null
        ),
        "1"
      )
    ) {
    } else {
      isErrorOccurred = await this.HedefTanimComponent_154860_onChange_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HedefTanimPageInit();
    }
  }
}
